$(document).ready(function(){

    $('.js-print').click(function(){
        javascript:window.print()
    });



    // **************************************
    // Main Navigation Start

    var $mainNavigation = $('.main-navigation');

    // If an item with children is clicked
    $('.js-toggle-subnav > a').click(function(e){
        e.preventDefault();
        if ($(this).parent().is('.open')){
            closeSubnav($(this).parent().find('.subnav'));
        } else {
            openSubnav($(this).parent().find('.subnav'));
        }

    });

    function openSubnav(subnav){
        $('.subnav').hide();
        $('ul.level-0 li.open').removeClass('open');
        subnav.parent().addClass('open');
        subnav.slideDown('slow', function (){
        });
    }

    function closeSubnav(subnav){
        subnav.parent().removeClass('open');
        subnav.slideUp();
    }

    // Main Navigation End
    // **************************************
    

    // **************************************
    // Fancy Navigation Start
        
        $('.js-fancy-nav-btn').click(function(){

            //get current fancy nav and add class
            fancyNavElement = $(this).attr('nav');
            $('.js-fancy-nav[nav="' + fancyNavElement + '"]').slideToggle('active');
        });

        $('.js-close-fancy-nav').click(function(){
            console.log('hi...')
            $(this).closest('.js-fancy-nav').slideUp('active');
        });

    // Fancy Navigation End
    // **************************************




    if (location.hash) {
        var hash = (location.hash.substr(1));
        var accordions = Array.from($('.accordion .accordion-row .accordion-content ul'));
        if (accordions.length) {
            accordions.forEach(function(list){
                var listItems = Array.from(list.children);
                listItems.forEach(function(item){
                    var itemText = item.innerText.trim();
                    if (itemText.toLowerCase() === hash.toLowerCase()) {
                        $(item.closest('.accordion-content')).slideDown();
                        $(window).scrollTop($(item).offset().top - 50);
                    }
                })
            })
        }
    }

    // Mobile Navigation Start
    // **************************************
    var $mainNavigation = $('.main-navigation');

    // If an item with children is clicked
    $('.js-go-to-mobile-next-level > a').click(function(e){
        e.preventDefault();
        nextMobileLevel($(this).parent().find('.subnav'));
    });

    $('.js-go-to-mobile-prev-level').click(function(e){
        e.preventDefault();
        prevMobileLevel();
    });

    $('.js-toggle-mobile-nav').click(function(){
        $mainNavigation.toggleClass('mobile-nav-open');
        $mainNavigation.find('.mobile-navigation-wrapper').slideToggle();
    });


    function nextMobileLevel(subnav){
        $mainNavigation.addClass('mobile-subnav-open');
        $('.subnav').removeClass('visible');
        subnav.addClass('visible');
    }

    function prevMobileLevel(){
        $mainNavigation.removeClass('mobile-subnav-open');
    }



    var activeSubnavName = '{% if craft.request.getSegment(1) is defined %}{{ craft.request.getSegment(1) }}{% endif %}';

    var activeSubnav = $('.subnav[subnav-id="'+activeSubnavName+']');
    if(activeSubnav.parent().hasClass("has-subnav")){
        nextMobileLevel(activeSubnav);
    }


    // Checks on click targets. Closes certain menus dependant on target
    $(document).click(function(e) {
        e.stopPropagation();
        var target = e.target;
        //console.log(target);
        // if (!$(target).is('.js-fancy-nav') && !$(target).is('.js-fancy-nav-btn') && !$(target).is('.js-close-fancy-nav')) {
        //     $('.js-fancy-nav').slideUp('active');
        // }

        if (!$(target).is('.subnav') && !$(target).parents().is('.subnav') && !$(target).is('ul.level-0 li.open a')) {
            closeSubnav($('ul.level-0 li.open .subnav'));
        }

        if (!$(target).is('.js-open-search i') && !$(target).is('.js-open-search') && !$(target).is('.main-navigation__search') && !$(target).parents().is('.main-navigation__search')) {
            closeSearch();
        }

        if (!$(target).is('.js-open-share i') && !$(target).is('.js-open-share') && !$(target).is('.share-menu') && !$(target).parents().is('.share-menu')) {
            closeShare();
        }
    });



    // **************************************
    // Search Start


    $('.js-open-search').click(function(e){
        e.preventDefault();
        openSearch();
    });

    $('.js-close-search').click(function(e){
        e.preventDefault();
        closeSearch();
    });



    function openSearch(){
        $mainNavigation.addClass('is-searching');
        $('body').addClass('is-searching');
        $( "#search" ).focus();
        closeShare();
    }

    function closeSearch(){
        $mainNavigation.removeClass('is-searching');
        $('body').removeClass('is-searching');
    }

    // Search End
    // **************************************


    // Dynamic Search start


    $(document).ajaxStart(function(){
        $('.ajax-loader').fadeIn();
    });
    $(document).ajaxComplete(function(){
        $('.ajax-loader').fadeOut();
    });
    $("#search").keyup(function(event) {
        if (event.keyCode === 13) {
            $("#submit-filters").click();
        }
    });

    $('#search').keyup(_.debounce(doSearch , 800));
    var historySupport = !!(window.history && history.pushState);

    function doSearch(){
        var search = $('#search').val();
        console.log(search.length);
        if (search.length == 0){
            $('#query-container').fadeOut();
        } else {
            if($('#search')[0].checkValidity()){
                console.log(search);
                ajaxCall(search);
                // e.stopPropagation();
            }
            else{
                $.fancybox.open($("#search-error"));
            }
        }

    }



    function ajaxCall(search){
        $('.search-panel__loading').fadeIn();
        $('#query-container').fadeOut();
        $.ajax('/search/results?&q='+search, {
            dataType : 'html',
            success : function (response) {
                $('.search-panel__loading').fadeOut();
               // console.log(response);
                refreshResults(response, search);
                $('#query-container').fadeIn();
                if (historySupport) {
                    // Update the browser's address bar
                 //   history.pushState(null, null, '/search/results?&q='+search);
                }
            }
        });
    }
    function refreshResults (html, search)
    {
        var $html = $('<div />').append(html);
        // $.when($('#query-container').fadeOut(),$('#query-header').fadeOut(),$('#query-title').fadeOut()).then(function(){
       // $('#query-breadcrumbs').html($html.find('#query-breadcrumbs').html()).fadeIn();
        $('#query-container').html($html.find('.search-results-wrapper').html()).fadeIn();
       // $('#query-header').html($html.find('#query-header').html()).fadeIn();
       // $('#query-title').html($html.find('#query-title').html()).fadeIn();
        // })
        var results = $html.find('.search-result').length;
        dataLayerSearch(search, results);

        const searchResultsScroller = document.querySelector('#search-results-scroller');
        const ps = new PerfectScrollbar(searchResultsScroller);


    }


    // Search Data Layer
    window.dataLayer = window.dataLayer || [];
    // Data Layer
    function dataLayerSearch(search, results){
        
        dataLayer.push({
          'event': 'searchTermQuery',
          'searchKeyword': search,
        });
    }

    $('body').on('click', '.search-results li a', function(){
        // Need to code it this way since click events on ajax generated content dosn't work with the jquery .click function
        var product = $(this).find('h2').text();
        var url = $(this).attr('href');
        dataLayer.push({
          'event': 'searchResultSelection',
          'resultSelected':product.trim(),
          'resultSelectedUrl': url
        });

    });


 // Search End


    $('.js-open-share').click(function(e){
        e.preventDefault();
        openShare();
    });

    $('.js-close-share').click(function(e){
        e.preventDefault();
        closeShare();
    });


    function openShare(){
        $mainNavigation.addClass('is-sharing');
    }

    function closeShare(){
        $mainNavigation.removeClass('is-sharing');
    }


    var scrollThrottleTimeout;
    $(window).bind(
        'scroll',
        function()
        {
            onPageScroll();
        }
    );


    function onPageScroll(){
        // console.log("Scrolled");
        if ($(window).scrollTop() >= 80) {
            $('.main-navigation').addClass('is-fixed');
            $('body').addClass('is-fixed');
            $('.fancy-nav').addClass('is-scrolled');
        } else {
            $('.main-navigation').removeClass('is-fixed');
            $('body').removeClass('is-fixed');
            $('.fancy-nav').removeClass('is-scrolled');
        }
    }



    // Select box
    console.log('here')
    console.log(typeof $("select.minimalect").minimalect)
    if (typeof typeof $("select.minimalect").minimalect !== 'undefined' && $("select.minimalect").length > 0) {
        $("select.minimalect").minimalect({
            placeholder: null,
            searchable: false,
            class_active: 'active',
            class_disabled: 'disabled',
            empty: ""
        });
    }

    // old accordion
    // $('.accordion-title').click(function(e) {
    //     e.preventDefault();
    //     $(this).toggleClass('show');
    //     var $this = $(this); 

    //     if ($this.next().hasClass('show')) {
    //         $this.next().removeClass('show');
    //         $this.next().slideUp(0);
    //     } else {
    //         $this.parent().parent().find('.accordion-row .accordion-content').removeClass('show');
    //         $this.parent().parent().find('.accordion-ro .accordion-content').slideUp(0);
    //         $this.next().toggleClass('show');
    //         $this.next().slideToggle(0);
    //     }
    // });
    

    // Accordion
    $('.accordion-block__preview[aria-controls]').click(function(){
        // $(this).toggleClass('open-accordion');

        var ariaControlsId = $(this).attr('aria-controls');
        // $('.accordion-block__main-content[id="' + ariaControlsId + '"]').slideToggle();

        var ariaExpanded = $(this).attr('aria-expanded');
        console.log(ariaExpanded);

        if (ariaExpanded == 'false'){
            $(this).attr("aria-expanded","true");
        } else {
            $(this).attr("aria-expanded","false");
        }

    });



    // Toggle Inline Image Size
    
    $('.inline-image[imgid]').click(function(){
        var imgId = $(this).attr('imgid');
        console.log(imgId);
        $(this).toggleClass('enlarge-image');
    });


    // fancybox settings 
    $('[data-fancybox="gallery"]').fancybox({
        keyboard: true,
        preventCaptionOverlap: false, 
        infobar: false,
        buttons: [
            "slideShow",
            "thumbs",
            "close"
        ],
        idleTime: 300,
    });






    


    // color notes toggle 
    $('.js-color-info-btn').click(function(){
        var color = $(this).attr('color');
        $('.color-info-content[color="' + color + '"]').fadeToggle();
    });

    $('.js-color-info-btn').hover(function(){
        var color = $(this).attr('color');
        $('.color-info-content[color="' + color + '"]').fadeToggle();
    });


    //add a smooth scroll to some links
    $('.js-smooth-scrolling-link').click(function(e){
        event.preventDefault(e);
        
        var smoothBtnId = $(this).attr('smoothScrollingLinkId');
        console.log(smoothBtnId);
        $('html, body').animate({
            scrollTop: $('#' + smoothBtnId).offset().top - 60
        }, 2000 );

    });

    //add function for button to open accordion
    $('.js-open-accordion-btn').click(function(e){
        event.preventDefault(e);

        var accordionControls = $(this).attr('openAccordionControls');

        var selectedAccordion = $('.accordion-block__preview[aria-controls="' + accordionControls + '"]');
        selectedAccordion.attr("aria-expanded","true");
    });

    //wistia disable
    window._wq = window._wq || [];
        window._wq.push(function (W) {
        W.consent(false);
        console.log("tracking?", W.consent()); // returns true or false
    });



    // Contact Us form - update URL params based on Inquiry Type selected (this allows us to have control over the Return URL)
    var contactFormTypes = $('#contactForm').find('.multiplechoice input');
    var updateParams = function(url) {
        $(contactFormTypes).on('click', function() {
            // Clear all existing search parameters
            url.search = '';
    
            // Append new parameters
            url.searchParams.append('type', $(this)[0].value);
    
            // Update the URL without reloading the page
            window.history.pushState({}, '', url);
        })
    }
    if (window.location.pathname === '/contact-us' || window.location.pathname === '/contact-us/') {
        const url = new URL(window.location.href);
        url.search = ''; // clear all params
        url.searchParams.append('type', 'general'); // set initial type to be general inquiry
        window.history.pushState({}, '', url); // update URL without reloading page

        updateParams(url);
    }
    

});

